import * as React from 'react';
import S from './CheckboxList.styles';
const CheckboxListOption = React.forwardRef((props, ref) => {
    const { id: initialId, children, ...otherProps } = props;
    const id = `${initialId}-${otherProps.name}${otherProps.value ? `-${otherProps.value}` : ''}`;
    return (React.createElement(S.Option, null,
        React.createElement(S.Input, { ref: ref, id: id, type: "checkbox", value: otherProps.value, ...otherProps }),
        React.createElement(S.Label, { htmlFor: id }, children)));
});
CheckboxListOption.displayName = 'CheckboxListOption';
export { CheckboxListOption };
const CheckboxList = React.forwardRef(({ children, layout, ...props }, ref) => {
    return (React.createElement(S.Container, { ref: ref, "data-layout": layout ?? 'horizontal', ...props }, children));
});
CheckboxList.displayName = 'CheckboxList';
export default CheckboxList;
